import { render, staticRenderFns } from "./SeibiBuhinLink.vue?vue&type=template&id=6442f008&scoped=true&"
import script from "./SeibiBuhinLink.vue?vue&type=script&lang=ts&"
export * from "./SeibiBuhinLink.vue?vue&type=script&lang=ts&"
import style0 from "./SeibiBuhinLink.vue?vue&type=style&index=0&id=6442f008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442f008",
  null
  
)

component.options.__file = "SeibiBuhinLink.vue"
export default component.exports